import {type, define, Record, attr, Collection} from "type-r";
import {dateToJson} from "./utils";
import Ownership from "./Ownership";

@define
class ProfileModel extends Record {
    @type(String).toJSON(false).as user: number;

    @attr(Ownership.Collection) ownerships: Collection<Ownership>
    @attr username: string;
    @attr last_name: string;
    @attr first_name: string;
    @attr father_name: string;
    @attr(String.has.toJSON(false)) phone: string;
    @attr phone2: string;
    @attr email: string;

    @attr(Date.has.toJSON(dateToJson)) birth_date: Date;
    @attr(String.has.toJSON(false)) create_date: string;
    @attr(Boolean.has.toJSON(false)) need_change_password: boolean;

    get land_plots(){ return this.ownerships; }
    hasChangesForSave() {
        const fieldsToSave =
            Object.keys(this.changed).filter(fieldName=>
                ProfileModel.attributes[fieldName].options.toJSON === undefined ||
                ProfileModel.attributes[fieldName].options.toJSON() !== undefined
            );
        return fieldsToSave.length > 0;
    }
}

export default ProfileModel;


// WEBPACK FOOTER //
// ./src/models/ProfileModel.ts